import { MapContainer, TileLayer, Marker, ZoomControl, useMap, useMapEvents } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";
import { TORPIGNATTARA } from "../lib/api";
import { SpotMarkers } from "./SpotMarkers";

const TILES = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
const ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

const pickIcon = L.divIcon({ className: "pick-pin", html: '<div class="dot"></div>', iconSize: [0, 0] });

const ClickPicker = ({ onPick }) => {
  useMapEvents({ click: (e) => onPick([e.latlng.lat, e.latlng.lng]) });
  return null;
};

const FlyTo = ({ pos, zoom = 18 }) => {
  const map = useMap();
  useEffect(() => { if (pos) map.flyTo(pos, zoom); }, [pos, zoom, map]);
  return null;
};

export const SpotMap = ({ spots = [], now, onSelect, onSelectGroup, picked, onPick, flyTo, flyZoom, className = "", children }) => (
  <div className={className} data-testid="spot-map">
    <MapContainer center={picked || TORPIGNATTARA} zoom={16} scrollWheelZoom zoomControl={false} className="h-full w-full">
      <TileLayer url={TILES} attribution={ATTR} className="dark-tiles" />
      <ZoomControl position="topright" />
      {spots.length > 0 && <SpotMarkers spots={spots} now={now} onSelect={onSelect} onSelectGroup={onSelectGroup} />}
      {onPick && <ClickPicker onPick={onPick} />}
      {picked && <Marker position={picked} icon={pickIcon} />}
      {children}
      <FlyTo pos={flyTo} zoom={flyZoom} />
    </MapContainer>
  </div>
);
